import MainLayout from "../layouts/MainLayout";
import * as React from "react";
import * as ReactDOM from "react-dom/client";


import {
    createBrowserRouter

} from "react-router-dom";

import {
    Landing,
    Login,

    PasswordChange,


    About,

  Certificates
} from '../pages'
import Parcel from "../pages/Parcel";
import Parcelin from "../pages/Parcelin";
import Parcelout from "../pages/Parcelout";
import Parcelslist from "../pages/Parcelslist";
import Details from "../pages/Details";
import Logs from "../pages/Parcellogs";
import Parcelreturn from "../pages/Parcelreturn";



export const router = createBrowserRouter([
    {
        path: '/admin',
        element: <MainLayout/>,

        children: [

            {
                path: '/admin',
                element: <Landing/>
            },




            {
                path: '/admin/password-change',
                element: <PasswordChange/>
            },

            {
                path: '/admin/about',
                element: <About/>
            }
            ,
            {
                path: '/admin/centers',
                element: <Certificates/>
            },
            {
                path: '/admin/parcel-delivered',
                element: <Parcel/>
            },
            {
                path: '/admin/parcel-in',
                element: <Parcelin/>
            },
            {
                path: '/admin/parcel-out',
                element: <Parcelout/>
            } ,
            {
                path: '/admin/parcel-return',
                element: <Parcelreturn/>
            } ,
            {
                path: '/admin/parcel-list',
                element: <Parcelslist/>
            } ,









        ]


    },
    {
        path:'/parcel/:id',
        element: <Details/>
    },
    {
        path:'/parcel/logs/:id',
        element: <Logs/>
    },

    {
        path: '/',
        element: <Login/>
    }

])